import { TemporaryStorageService } from "@imaios-js/utils";
import {
    STORAGE_KEY
} from "@assets/js/imaios-connection-management/config.constant";
import {
    fetch
} from "@assets/js/imaios-global/imaios-global";
import loginManagementService
    from "@assets/js/imaios-connection-management/login-management-service";

let prefix = 'userConsent_';
let commonUserConsent = 'userConsent_10';
let commonUser = 10;
let legalCookieLifeTime = 395; // 13 months
const USER_CONSENT = {
    ACCEPTED: 1,
    REFUSED: 0
};
const EXPIRATION = {
    EXPIRED: 0,
    ACTIVE: 1
};

function hex_to_ascii(str1) {
    var hex = str1.toString();
    var str = '';
    for (var n = 0; n < hex.length; n += 2) {
        str += String.fromCharCode(parseInt(hex.substr(n, 2), 16));
    }
    return str;
}


window.ImaiosUserConsent = class UserConsent {
    static hasBeenInitialized = false;

    init() {
        return loginManagementService.awaitConnection()
            .then(() => this.onInit());
    }

    onInit() {
        if (UserConsent.hasBeenInitialized) {
            return;
        }
        UserConsent.hasBeenInitialized = true;

        this.checkStorageExpiration(prefix + this.getRemoteId()).then(expiration => {
            if (expiration === EXPIRATION.EXPIRED) {
                this.checkStorageExpiration(commonUserConsent).then(commonExpiration => {
                    if (commonExpiration === EXPIRATION.EXPIRED) {
                        $('#userConsentModal').modal({
                            show: true,
                            backdrop: 'static',
                            keyboard: false
                        });
                    } else {
                        // If the current session is not the same session when the cookie was accepted, and we are connected,
                        // and we don't have accepted the consent while being connected we suppose that if the user has accepted
                        // consent while being anonymous, he will accept it while being connected
                        if (this.getRemoteId() !== undefined) {
                            let cookie_10 = TemporaryStorageService.get(commonUserConsent);
                            cookie_10.session_user_consent = this.currentSessionHash();
                            cookie_10.imUserId = this.getRemoteId();
                            TemporaryStorageService.add(prefix + this.getRemoteId(), cookie_10, this.convertExpire(legalCookieLifeTime)); // Convert expire to milliseconds
                            this.sendUserConsentData(cookie_10);
                        }
                    }
                });
            }
        });
    }

    getRemoteId() {
        if (TemporaryStorageService.get(STORAGE_KEY.IMAIOS_USER_INFORMATION) !== null) {
            const data = TemporaryStorageService.get(STORAGE_KEY.IMAIOS_USER_INFORMATION) ?? null;
            if (data !== null) {
                return (data.id !== null && data.id !== undefined) ? data.id : commonUser;
            } else {
                return commonUser;
            }
        }
    }

    getSessionId() {
        if (TemporaryStorageService.get(STORAGE_KEY.IMAIOS_USER_INFORMATION) !== null) {
            const data = TemporaryStorageService.get(STORAGE_KEY.IMAIOS_USER_INFORMATION) ?? null;
            if (data !== null) {
                return (data.session_id !== null && typeof data.session_id !== 'undefined') ? data.session_id : null;
            } else {
                return null;
            }
        }
    }

    getConsentDate() {
        return new Promise(resolve => {
            if (window.imConsent) {
                return resolve(window.imConsent.consent_timestamp ?? null);
            } else {
                fetch(`/${imaios.getSiteAccess()}/api/user/user-consent/check`,
                    {
                        method: "GET"
                    })
                    .then(res => res.json())
                    .then(data => {
                        if (data !== null) {
                            return resolve((data.consent_timestamp !== null && typeof data.consent_timestamp !== 'undefined') ? parseInt(data.consent_timestamp) : null);
                        }
                    });
            }
            return resolve(null);
        });
    }

    // check if storage expires
    checkStorageExpiration(name) {
        const current = Math.round(Date.now() / 1000);
        return new Promise(resolve => {
            // Remove key in localstorage if information are expired
            TemporaryStorageService.checkExpire(name);

            if (TemporaryStorageService.has(name)) {
                return resolve(EXPIRATION.ACTIVE);
            } else if (name !== commonUserConsent) { // Case when we don't have saved information
                this.getConsentDate().then(consentDate => {
                    // If the consent was already accepted and is not expired then
                    // add information to localstorage
                    const expire13Month = (this.convertExpire(legalCookieLifeTime) / 1000) - current;
                    // Not expired save information
                    if (consentDate !== null && consentDate + expire13Month > current) {
                        // Set expire 13month after the consent date (*1000 because we convert to ms)
                        this.userConsentSave(USER_CONSENT.ACCEPTED, false, (consentDate + expire13Month) * 1000);
                        return resolve(EXPIRATION.ACTIVE);
                    }
                    return resolve(EXPIRATION.EXPIRED);
                });
            } else {
                return resolve(EXPIRATION.EXPIRED);
            }
        });
    }

    extractHostname(url) {
        let hostname;
        //find & remove protocol (http, ftp, etc.) and get hostname

        if (url.indexOf("://") > -1) {
            hostname = url.split('/')[2];
        } else {
            hostname = url.split('/')[0];
        }

        //find & remove port number
        hostname = hostname.split(':')[0];
        //find & remove "?"
        hostname = hostname.split('?')[0];

        return hostname;
    }

    // extract root domain
    extractRootDomain(url) {
        let domain = this.extractHostname(url),
            splitArr = domain.split('.'),
            arrLen = splitArr.length;

        //extracting the root domain here
        //if there is a subdomain
        if (arrLen > 2) {
            domain = splitArr[arrLen - 2] + '.' + splitArr[arrLen - 1];
            //check to see if it's using a Country Code Top Level Domain (ccTLD) (i.e. ".me.uk")
            if (splitArr[arrLen - 2].length === 2 && splitArr[arrLen - 1].length === 2) {
                //this is using a ccTLD
                domain = splitArr[arrLen - 3] + '.' + domain;
            }
        }
        return domain;
    }

    // Convert Expire to timestamp
    convertExpire(expire) {
        // set time, it's in milliseconds
        const today = new Date();
        today.setTime(today.getTime());
        expire = expire * 1000 * 60 * 60 * 24;
        return today.getTime() + expire;
    }

    getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    setCookie = function (name, value, expires, path, domain, secure) {
        // set time, it's in milliseconds
        var today = new Date();
        today.setTime(today.getTime());

        /*
         if the expires variable is set, make the correct
         expires time, the current script below will set
         it for x number of days, to make it for hours,
         delete * 24, for minutes, delete * 60 * 24
         */
        if (expires) {
            expires = expires * 1000 * 60 * 60 * 24;
        }
        var expires_date = new Date(today.getTime() + (expires));

        document.cookie = name + "=" + escape(value) +
            ((expires) ? ";expires=" + expires_date.toGMTString() : "") +
            ((path) ? ";path=" + path : "") +
            ((domain) ? ";domain=" + domain : "") +
            ((secure) ? ";secure" : "");
    }

    convertHash(name) {
        return window.btoa(hex_to_ascii(window.imaios.sha256(name)));
    }

    currentSessionHash() {
        return (this.getSessionId()) ? this.convertHash(this.getSessionId()) : null;
    }

    checkConsent() {
        let state = false;
        const name = prefix + this.getRemoteId();
        TemporaryStorageService.checkExpire(name);
        const consent = TemporaryStorageService.get(name);
        if (consent !== null) {
            if (consent.cookie_consent === 1) {
                state = true;
            }
        }
        return state;
    }

    userConsentSave(cookie_consent, send = true, expire = null) {
        const analyticsDisable = 'analytics-disable';
        let state = cookie_consent === USER_CONSENT.REFUSED;
        imaios.store(analyticsDisable, state);

        const rootDomain = this.extractRootDomain(window.location.href);

        // Cookie will expire right after closing browser for anonymous
        let expire_storage;
        let imUserId;
        const currentTimestamp = Math.round(Date.now() / 1000);

        if (this.getRemoteId() !== commonUser && this.getRemoteId() !== null && this.getRemoteId() !== undefined) {
            expire_storage = this.convertExpire(legalCookieLifeTime);
            imUserId = this.getRemoteId();
        } else {
            expire_storage = this.convertExpire(1);
            imUserId = commonUser;
        }
        let preferences = {
            session_user_consent: this.currentSessionHash(),
            cookie_consent: cookie_consent,
            path: '/',
            rootDomain: rootDomain,
            imUserId: imUserId
        };
        preferences.consent_timestamp = (cookie_consent !== USER_CONSENT.REFUSED) ? currentTimestamp : null;

        // Register cookies preference
        TemporaryStorageService.add(prefix + imUserId, preferences, expire !== null ? expire : expire_storage); // Set expire time in milliseconds

        if (send) {
            // Record in newRelic / Rapid7 (logEntries) AND BDD
            this.sendUserConsentData(preferences);
        }
    }

    sendUserConsentData(preferences) {
        fetch(`/${imaios.getSiteAccess()}/api/user/user-consent`, {
            method: "POST",
            body: JSON.stringify(preferences)
        });
    }
};

export default window.ImaiosUserConsent;
